export function loadJS(doc, elemType, id, src, force, callback) {
    const el = doc.querySelectorAll(`#${id}`);
    if (el.length > 0) {
        if (!force) {
            return;
        }
        for (let i = 0; i < el.length; i++) {
            const parent = el[i].parentNode;
            parent.removeChild(el[i]);
        }
    }

    const fjs = doc.getElementsByTagName(elemType)[0];
    const js = doc.createElement(elemType);
    js.id = id;
    js.src = src;
    fjs.parentNode.insertBefore(js, fjs);
    if (callback) {
        js.onload = callback;
    }
}
